import {
  Dialog,
  DialogContent,
  DialogFooter,
  Icon,
  PrimaryButton,
} from "@fluentui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { FormSpinner } from "../../components/FormSpinner";
import { Flex, HSpace, StyledPrimaryButton } from "../../components/styled";
import { useSelector } from "../../store/hooks";
import {
  deleteLocationRoutine,
  setDeleteDialog,
} from "../../store/locations-page/locationsPage";

export const DeleteDialog = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { location } = useSelector((s) => s.locationsPage.deleteLocationDialog);
  const isLoading = useSelector(
    (s) => s.locationsPage.deleteLocationLoadStatus === "loading"
  );

  const close = () => {
    dispatch(
      setDeleteDialog({
        location: null,
        isOpen: false,
      })
    );
  };

  return (
    <Dialog
      hidden={false}
      dialogContentProps={{
        showCloseButton: true,
        title: (
          <Flex>
            <Icon iconName="Warning" /> <HSpace />
            <div>{t("greco.areYouSure")}</div>
          </Flex>
        ),
      }}
      onDismiss={close}
    >
      <div>{t("ram.delete.location.label")}</div>

      <DialogFooter>
        <StyledPrimaryButton
          text={t("greco.delete")}
          onClick={() => {
            dispatch(
              deleteLocationRoutine.trigger({
                locationId: location.locationId,
              })
            );
          }}
          disabled={isLoading}
        />
      </DialogFooter>
      {isLoading && <FormSpinner />}
    </Dialog>
  );
};
